export default "__VITE_ASSET__4c336769__"